import {Module} from 'vuex';
import {DisplayOption} from '@/components/interfaces/ComponentOptions';
import {getBillboardCities, getStatuses} from '@/sports-schedule/EventService';
import {listForms} from '@/custom-forms/admin/FormServices';

interface EventState {
    formTypes: DisplayOption[];
}

export default {
    namespaced: true,
    state: {
        formTypes: [],
    },
    actions: {
        async loadReferenceData({commit, state}): Promise<void> {
            // Loads all reference data asynchronously.
            // Loads all at the same time so it is O(1) rather than O(n).
            // This makes a big difference for the initial load when it has to call the server for each reference type.
            // The normal case is either all will be loaded or none will but this isn't a guarantee
            const promises: Promise<any>[] = [];
            // Push the promise for each type that hasn't yet been loaded with a unique (arbitrary) type
            if (state.formTypes.length === 0) {
                promises.push(listForms().then(formTypes => ({ id: 1, results: formTypes })));
            }

            // When all are complete set the data for each type that returned data.
            (await Promise.all(promises)).forEach(result => {
                switch (result.id) {
                    case 1:
                        commit('setFormTypes', result.results);
                        break;
                }
            });
        }
    },
    mutations: {
        setFormTypes(state, payload: DisplayOption[]) {
            state.formTypes = payload;
        },
        clearFormTypes(state) {
            state.formTypes = [];
        }
    },
} as Module<EventState, any>;
